import styled from "styled-components";

const MainHeading = styled.h1``;

const SubHeadingOne = styled.h2``;

const SubHeadingTwo = styled.h4``;

const SubHeadingThree = styled.h6``;

const Paragraph = styled.p`
  font-weight: 500;
  letter-spacing: 0.1ch;
`;

export {
  MainHeading,
  SubHeadingOne,
  SubHeadingTwo,
  SubHeadingThree,
  Paragraph,
};
